import React, { useCallback, useEffect } from 'react';
import Switch from 'react-switch'
import { Tooltip } from 'antd'
import 'antd/dist/antd.min.css'
import globalHooks from '../../../hooks'
function Option() {

  const {
    isMask,
    setMask,
    isShowSelDiv,
    setShowSelDiv,
    // emitDispatchEvent,
  } = globalHooks()

  useEffect(() => {
    // window.postMessage('message', '*')
    // window.addEventListener('message', function (msg) {
    //     console.log(msg);
    // })
  }, [])

  // const navTo = useCallback((url: string) => {
  //   if (url) {
  //     window.open(url)
  //   }
  // }, [])

  // const open = useCallback((e: any) => {
  //   e.stopPropagation()
  //   setMask(true)
  // }, [setMask])

  const close = useCallback((e: any) => {
    e.stopPropagation()
    setMask(false)
  }, [setMask])

  return (
    <>
      <div
        className={`z-[999998] fixed w-[100%] h-[100%] top-0 left-0 bg-mask-bg ${isMask ? '' : 'hidden'}`}
        id='m2m_option_mask'
        onClick={close}
      />
      <div 
        onClick={e => e.stopPropagation()}
        className={`${isMask ? '' : 'hidden'} z-[999999] absolute top-[64px] right-[13px] flex items-center bg-white justify-between w-[252px] h-[48px] p-[12px] rounded-[8px] border border-lines shadow-[(0px 0px 4px rgba(0, 0, 0, 0.15))]`}
      >
        <div className=' font-Poppins text-base font-[400]'>Highlight Search</div>
        <Switch
          checked={isShowSelDiv} onChange={setShowSelDiv}
          checkedIcon={false}
          uncheckedIcon={false}
          width={44}
          height={24}
          onColor='#3FA1D9'
        />
      </div>
      <div
        className=' absolute right-[13px] top-[31px]'
        onClick={e => e.stopPropagation()}
      >
        <Tooltip title='settings' placement='bottomRight'>
          <img alt='empty' className=' cursor-pointer h-[24px] w-[24px]' src={require('../../../img/option_icon@3.png')} onClick={() => { setMask(true)  }} />
        </Tooltip>
      </div>
    </>
  );
}

export default Option;
